export const GenerateRandom = () =>{
    var randomstr = Math.round(+new Date()/1000);
    return randomstr;
  }